import LoadingIndicator from '../LoadingIndicator';
import { cn } from '@/lib/utils';
import { PageLoadingStateProps } from './types';

const PageLoadingState = (props: PageLoadingStateProps) => {
  const {
    className,
    indicatorClassName,
    label,
    size = 'xl'
  } = props;

  return (
    <div className={cn('flex flex-1 items-center justify-center', className)}>
      <LoadingIndicator
        className={indicatorClassName}
        label={label}
        size={size}
      />
    </div>
  );
};

export default PageLoadingState;